import { Link } from 'react-router-dom';
import { usePublicDevices } from '../hooks';
import { useMe } from '../../../hooks';
import { timeAgo } from '../../../shared/format';

const PHASE_LABEL: Record<string, { text: string; className: string }> = {
  live: { text: '实时', className: 'ok' },
  stale: { text: '数据陈旧', className: 'warn' },
  idle: { text: '空闲', className: '' },
  offline: { text: '离线', className: 'danger' },
};

export default function LiveDevices() {
  const me = useMe();
  const devices = usePublicDevices();
  const loggedIn = Boolean(me.data);
  const list = devices.data ?? [];

  return (
    <>
      <div className="page-head">
        <div>
          <div className="eyebrow">Live · Public</div>
          <h1>实时监视</h1>
        </div>
        <span className="badge">{loggedIn ? '已登录' : '公开浏览'}</span>
      </div>

      <p className="page-lead">
        这里可以看到设备是否在线。{loggedIn ? '点击设备进入实时画面。' : '进入设备查看实时数据与控制需要登录。'}
      </p>

      {devices.isLoading ? (
        <div className="empty">正在加载设备…</div>
      ) : list.length ? (
        <div className="public-device-grid">
          {list.map((device) => {
            const phase = PHASE_LABEL[device.phase] ?? PHASE_LABEL.offline;
            return (
              <Link key={device.id} to={`/ccs/live/${device.id}`} className="public-device">
                <div>
                  <div className="eyebrow">{device.site ?? 'CCS 设备'}</div>
                  <h2>{device.name}</h2>
                  <div className="mono muted">{device.id}</div>
                </div>
                <div className="badge-row">
                  <span className={`badge ${phase.className}`}>{phase.text}</span>
                  <span className="badge">{device.online ? '在线' : '离线'}</span>
                  {device.lastSeenAt ? <span className="badge">最近 {timeAgo(device.lastSeenAt)}</span> : null}
                </div>
                <div className="public-device-foot">
                  {loggedIn ? '进入设备 →' : '登录后进入 →'}
                </div>
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="empty">
          <b>还没有注册设备</b>
          管理员在设备页创建后，这里会显示设备的在线状态。
        </div>
      )}
    </>
  );
}